<template>
  <div class="rent">
    <h1>This is a rent page</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
